import API from "../../services/api";

export const getDashboard = async () => {

    const res = await API.get("/admin/dashboard");

    return res.data;

};

export const getRecentProviders = async () => {

    const res = await API.get("/admin/recent-providers");

    return res.data;

};

export const getRecentOrders = async () => {

    const res = await API.get("/admin/recent-orders");

    return res.data;

};